<template>
  <div class="container" style="display: flex;flex-direction: column">
    <!-- Header -->
    <h5 class="kt-font-primary title">
      Token Debugger
    </h5>
    <!-- Header -->

    <!-- Input Box -->
    <small v-show="!isTokenValid" style="color: red">Please enter valid token</small>
    <div class="input-group">
      <input
        id="token"
        ref="token"
        v-model="token"
        type="text"
        class="form-control"
        :class="{ 'border-red': !isTokenValid }"
        placeholder="Enter your token"
        required
        @input="trackCustomEvent({ event: 'input', action: 'type', target: 'input_box_content', value: token })"
      >
      <div class="input-group-append">
        <button
          class="btn btn-brand"
          type="button"
          @click="trackCustomEvent({ action: 'clicked', target: 'debug_content' }); getTokenDetail()"
        >
          Debug
        </button>
      </div>
    </div>
    <!-- Input Box -->

    <!-- Table -->
    <div id="table" class="kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded" style="display: none;">
      <table v-if="data" class="kt-datatable__table">
        <!-- <thead class="kt-datatable__head">
          <tr class="kt-datatable__row">
            <th data-field="Topic" class="kt-datatable__cell border-right">
              <span class="left-col-width">
                Topic
              </span>
            </th>
            <th data-field="Detail" class="kt-datatable__cell">
              <span class="right-col-width">
                Detail
              </span>
            </th>
          </tr>
        </thead> -->
        <tbody class="kt-datatable__body ps ps--active-y">
          <tr data-row="0" class="kt-datatable__row">
            <td class="kt-datatable__cell border-right">
              <span class="left-col-width">
                Name
              </span>
            </td>
            <td class="kt-datatable__cell">
              <span class="right-col-width">
                {{ data.name }}
              </span>
            </td>
          </tr>
          <tr data-row="1" class="kt-datatable__row">
            <td class="kt-datatable__cell border-right">
              <span class="left-col-width">
                Account
              </span>
            </td>
            <td class="kt-datatable__cell">
              <span class="right-col-width">
                {{ data.email }}
              </span>
            </td>
          </tr>
          <tr data-row="2" class="kt-datatable__row">
            <td class="kt-datatable__cell border-right">
              <span class="left-col-width">
                Created At
              </span>
            </td>
            <td class="kt-datatable__cell">
              <span class="right-col-width">
                <div>
                  {{ getFormatDate(data.createdAt) }} ({{ getDateInRelativeWord(data.createdAt) }})
                </div>
              </span>
            </td>
          </tr>
          <tr data-row="3" class="kt-datatable__row">
            <td class="kt-datatable__cell border-right">
              <span class="left-col-width">
                Last access
              </span>
            </td>
            <td class="kt-datatable__cell">
              <span class="right-col-width">
                <div v-if="data.lastAccess === 0">
                  -
                </div>
                <div v-else>
                  {{ getFormatDate(data.lastAccess) }} ({{ getDateInRelativeWord(data.lastAccess) }})
                </div>
              </span>
            </td>
          </tr>
          <tr data-row="4" class="kt-datatable__row">
            <td class="kt-datatable__cell border-right">
              <span class="left-col-width">
                Service/Quota
              </span>
            </td>
            <td class="kt-datatable__cell">
              <span class="right-col-width">
                <ul class="dash">
                  <li
                    v-for="(service, idx) in data.authorized"
                    :id="idx"
                    :key="idx"
                    style="margin-bottom: 10px;"
                  >{{ service.service | formatService }}<br>
                    <small>
                      <b>{{ service.quota.minute | formatQuota }}</b> req/min<br>
                      <b>{{ service.quota.day | formatQuota }}</b> req/day<br>
                      <b>{{ service.quota.month | formatQuota }}</b> req/month
                    </small>
                  </li>
                </ul>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else>
        <LoadingSpinner />
      </div>
    </div>
    <!-- Table -->
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import LoadingSpinner from '../components/LoadingSpinner'

export default {
  name: 'App',
  components: {
    LoadingSpinner
  },
  filters: {
    formatQuota (e) {
      return e === 9999999 || e === 999999 ? 'Unlimit' : e
    },
    formatService (e) {
      return e.replace('/nlp/', '')
    }
  },
  data () {
    return {
      token: null,
      data: null,
      isTokenValid: true
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions({
      getSingleTokenDeepDetailRequest: 'project/getSingleTokenDeepDetail',
      trackCustomEvent: 'user/trackCustomEvent'
    }),
    getDateInRelativeWord (date) {
      return moment(date).fromNow()
    },
    getFormatDate (date) {
      return moment(date).format('D MMM YYYY HH:mm:ss')
    },
    async getTokenDetail () {
      this.data = null
      document.getElementById('table').style.display = 'block'
      if (this.token) {
        this.token = this.token.replace(/\s/g, '')
        if (this.token !== '') {
          const result = await this.getSingleTokenDeepDetailRequest(this.token)
          if (result && result.status === 200) {
            this.data = result.data
            this.isTokenValid = true
          } else {
            document.getElementById('table').style.display = 'none'
            this.isTokenValid = false
            this.$refs.token.focus()
          }
        } else {
          document.getElementById('table').style.display = 'none'
          this.isTokenValid = false
          this.$refs.token.focus()
        }
      } else {
        document.getElementById('table').style.display = 'none'
        this.isTokenValid = false
        this.$refs.token.focus()
      }
    }
  }
}
</script>

<style scoped>
  .title {
    margin: 2em 0 1em 0;
  }

  #table {
    margin-top: 1em;
  }

  .border-right {
    border-right: -0.1px solid rgb(128, 128, 128) !important;
  }

  .left-col-width {
    width: 150px;
  }

  .right-col-width {
    width: 500px;
  }

  .border-red {
    border: 1px solid red;
  }

  ul {
    list-style-type: none;
  }

  ul.dash {
       list-style: none;
       margin-left: 0;
       padding-left: 1em;
     }
  ul.dash > li:before {
    display: inline-block;
    content: "–";
    width: 1em;
    margin-left: -1em;
  }
</style>
